// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectNative_root__1ifRr","sSmall":"SelectNative_sSmall__3Mgsr","error":"SelectNative_error__1tsjo","disabled":"SelectNative_disabled__2z15E"};